import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import apiClient from "../components/apiClient";
import "@ckeditor/ckeditor5-ui/theme/globals/globals.css";
import "@ckeditor/ckeditor5-theme-lark/theme/theme.css";
import DOMPurify from "dompurify";

export const sanitizeHTML = (html) => ({
  __html: DOMPurify.sanitize(html),
});

const Accordion = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const [termCondition, setTermCondition] = useState("");

  useEffect(() => {
    const fetchTermCondition = async () => {
      try {
        const response = await apiClient.get("support/termscondition");
        if (response.data && response.data.length > 0) {
          setTermCondition(response.data[0].termscondition);
        }
      } catch (error) {
        console.error("Failed to fetch About Us content:", error);
      }
    };

    fetchTermCondition();
  }, []);

  return (
    <>
      <section className="py-20">
        <div className="mt-8 mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          {/* <div
            className="ck-content mt-4 whitespace-pre-wrap text-black"
            dangerouslySetInnerHTML={{ __html: termCondition }}
          /> */}
          <div
            className="ql-editor"
            dangerouslySetInnerHTML={{ __html: termCondition }}
          />
        </div>
      </section>
      <Footer></Footer>
    </>
  );
};

export default Accordion;
